import React from 'react'
import classNames from 'classnames'

import styles from './FeaturedItem.module.scss'
import { Link } from 'gatsby'
import { ReactComponent as FeaturedSVG } from './FeaturedSVG.svg'
import { ReactComponent as ArrowSVG } from './ArrowSVG.svg'

function FeaturedItem({ isDarkMode }: { isDarkMode?: boolean }) {
  return (
    <Link to={'/blog/power-of-smart-signals-fraud-detection-prevention/'} rel='noreferrer' style={{ height: '100%' }}>
      <div className={classNames(styles.container, { [styles.darkContainer]: isDarkMode })}>
        <h5>Featured</h5>
        <FeaturedSVG />
        <div className={styles.info}>
          <h4>Understanding Smart Signals</h4>
          <p className={styles.link}>
            Read More <ArrowSVG className={styles.arrow} />
          </p>
        </div>
      </div>
    </Link>
  )
}

export default FeaturedItem
